import React from 'react'
import { Badge, Card, Col, Row } from "react-bootstrap";
import { ReactComponent as Flight } from "../../../../assets/images/icon_svg/flight.svg";
import { ReactComponent as Truck } from "../../../../assets/images/icon_svg/car_timline.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/images/icon_svg/arrow_left.svg";
import { ReactComponent as ArrivedIcon } from "../../../../assets/images/icon_svg/gren_circle.svg";
import { ReactComponent as CheckIcon } from "../../../../assets/images/icon_svg/close_history.svg";
import { ReactComponent as GrayCircle } from "../../../../assets/images/icon_svg/gray_circle.svg"; 
import { ReactComponent as OrngCircle } from "../../../../assets/images/icon_svg/orng_circle.svg";  
import { ReactComponent as BlueCircle } from "../../../../assets/images/icon_svg/blue_circle.svg"; 
import { ReactComponent as InfoIcon } from "../../../../assets/images/icon_svg/infoIcon.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/images/icon_svg/red_cross.svg";
import { ReactComponent as OutgoingFlight } from "../../../../assets/images/icon_svg/outgoing_plane.svg";

const Connection = () => {

  const INCOMING_FLIGHTS = [
    {
      id: "EK147 / 05-04-2026",
      status: "Arrived",
      from: "SIN",
      to: "FRA",
      times: {
        STD: ["01:45", "06 APR"],
        ETD: ["01:45", "06 APR"],
        ATD: ["01:52", "06 APR"],
        STA: ["06:10", "07 APR"],
        ETA: ["06:10", "07 APR"],
        ATA: ["01:07", "07 APR"],
      },
      tag: "EK4091T",
      awbCount: "2 AWBs · 15 pcs",
      ct: "10h 25m CT",
      ctVariant: "success",
      awbs: ["176-12345675", "176-12345675", "176-12345675"],
    },
    {
      id: "EK045 / 05-04-2026",
      status: "Delayed",
      from: "SIN",
      to: "FRA",
      times: {
        STD: ["01:45", "06 APR"],
        ETD: ["01:45", "06 APR"],
        ATD: ["01:52", "06 APR"],
        STA: ["06:10", "07 APR"],
        ETA: ["06:10", "07 APR"],
        ATA: ["01:07", "07 APR"],
      },
      tag: "EK4091T",
      awbCount: "2 AWBs · 15 pcs",
      ct: "6h 45m CT",
      ctVariant: "warning",
      connRisk: "Connection at Risk",
      awbs: ["176-12345675", "176-12345675", "176-12345675"],
    },
    {
      id: "EK027 / 05-04-2026",
      status: "En Route",
      from: "SIN",
      to: "FRA",
      times: {
        STD: ["01:45", "06 APR"],
        ETD: ["01:45", "06 APR"],
        ATD: ["01:52", "06 APR"],
        STA: ["06:10", "07 APR"],
        ETA: ["06:10", "07 APR"],
        ATA: ["—", ""],
      },
      tag: "EK4091T",
      awbCount: "2 AWBs · 15 pcs",
      ct: "12m CT",
      ctVariant: "danger",
      missed: "Likely Missed",
      awbs: ["176-12345675", "176-12345675", "176-12345675"],
    },
  ];

  const OUTGOING_FLIGHTS = [
    {
      id: "EK962 / 05-04-2026",
      status: "Scheduled",
      from: "AMS",
      to: "MIA",
      times: {
        STD: ["10:30", "08 APR"],
        ETD: ["—", ""],
        ATD: ["—", ""],
        STA: ["06:10", "09 APR"],
        ETA: ["06:25", "09 APR"],
        ATA: ["—", ""],
      },
      tag: "EK4091T",
      awbCount: "2 AWBs · 15 pcs",
      ct: "10h 25m CT",
      ctVariant: "success",
      awbs: ["176-12345675", "176-12345675", "176-12345675"],
    },
    {
      id: "EK442 / 05-04-2026",
      status: "Scheduled",
      from: "AMS",
      to: "MIA",
      times: {
        STD: ["10:30", "08 APR"],
        ETD: ["—", ""],
        ATD: ["—", ""],
        STA: ["06:10", "09 APR"],
        ETA: ["06:25", "09 APR"],
        ATA: ["—", ""],
      },
      tag: "EK4091T",
      awbCount: "2 AWBs · 15 pcs",
      ct: "10h 25m CT",
      ctVariant: "success",
      awbs: ["176-12345675", "176-12345675", "176-12345675"],
    },
  ];

  const borderAccent = {
    warning: "3px solid #EF9F27",
    danger: "3px solid #dc3545",
  };

  const FlightCard = ({ flight }) => {
    const cardClass =
      flight.ctVariant === "warning"
        ? "flight_card warning-card"
        : flight.ctVariant === "danger"
          ? "flight_card danger-card"
          : "flight_card";

    return (
      <Card className={`mb-2 ${cardClass}`}>
        <Card.Body className="p-0">
          <div className="card_header">
            <span className="flight_id">
              {flight.status === "Scheduled" ? (
                <OutgoingFlight className='me-2' />
              ) : (
                <Flight className='me-2' />
              )}
              {flight.id}

            </span>

            <Badge
              bg="none"
              className={`status-badge ${flight.status === "Arrived"
                ? "arrived_btn"
                : flight.status === "Scheduled"
                  ? "gray_btnn"
                  : flight.status === "Delayed"
                    ? "orng_btnn"
                    : flight.status === "En Route"
                      ? "blue_btnn"
                      : ""
                }`}
            >
              {
                flight.status === "Arrived" ? (
                  <ArrivedIcon className="me-1" />
                ) : flight.status === "Delayed" ? (
                  <OrngCircle className="me-1" />
                ) :
                  flight.status === "En Route" ? (
                    <BlueCircle className="me-1" />
                  )
                    :
                    (
                      <GrayCircle className="me-1" />
                    )
              }
              {flight.status}
            </Badge>
          </div>

          {/* <div className="flight_route">
            <span className="airport_code">{flight.from}</span>

            <span className="route_arrow">→</span>

            <span className="airport_code">{flight.to}</span>
          </div> */}
          <div className="flight_route">
            <div className="airport_code">{flight.from}</div>

            <div className="route_arrow">
              <span><ArrowLeft /></span>
            </div>

            <div className="airport_code">{flight.to}</div>
          </div>

          <Row className="flight_times g-0">
            {Object.entries(flight.times).map(([label, [value, date]]) => (
              <Col key={label}>
                <div className="time_label">{label}</div>
                <div className="time_value">{value}</div>
                <div className="time_date">{date}</div>
              </Col>
            ))}
          </Row>

          <div className="flight_info">
            <div className="left_info">
              <Badge bg="none" className="flight_info_badge">
                <Truck className='me-1'/> {flight.tag}
              </Badge>
              <span>{flight.awbCount}</span>


            </div>
            <div>
              {flight.connRisk && (
                <span className="connection_risk me-2">
                  {flight.connRisk}
                </span>
              )}

              {flight.missed && (
                <span className="missed_connection me-2">
                  {flight.missed}
                </span>
              )}
              <Badge
                bg="none"
                className={`ct_badge ${flight.status === "Arrived" || flight.status === "Scheduled"
                  ? "grnn_btn"
                  : flight.status === "Delayed"
                    ? "risk_btn"
                    : flight.status === "En Route"
                      ? "danger_btnn"
                      : ""
                  }`}

              >
                {
                  flight.status === "Arrived" ? (
                    <CheckIcon className="me-1" />
                  ) : flight.status === "Scheduled" ? (
                    <CheckIcon className="me-1" />
                  ) : flight.status === "Delayed" ? (
                    <InfoIcon className="me-1" />
                  ) : flight.status === "En Route" ? (
                    <CrossIcon className="me-1" />
                  ) : null
                }

                {flight.ct}
              </Badge>
            </div>

          </div>

          <div className="awb_list">
            <h6>AWBs:</h6>
            {flight.awbs.map((awb, index) => (

              <span
                key={index}
                className="awb_badge"
              >
                {awb}
              </span>
            ))}
          </div>
        </Card.Body>
      </Card>
    );
  };

  return (
    <div className='rfs_connection'>
      <Row>
        <Col md={4} className='pe-0'>
          <div className="mb-1 incoming_flight">
            <h6>Incoming flights
              <span className='ms-2'>
                3 flights · 9 AWBs · 63 pcs
              </span>
            </h6>
            <p className="mb-3">
              Flights arriving before truck departure · FRA boardpoint
            </p>

            {INCOMING_FLIGHTS.map((flight) => (
              <FlightCard key={flight.id} flight={flight} />
            ))}
          </div>
        </Col>

        <Col md={4} className=''>
          <div className="mb-1 outgoing_flight">
            <h6>Outgoing flights
              <span className='ms-2'>
                2 flights · 6 AWBs · 40 pcs
              </span>
            </h6>
            <p className="mb-3">
              Flights departing after truck arrival · AMS offpoint
            </p>

            {OUTGOING_FLIGHTS.map((flight) => (
              <FlightCard key={flight.id} flight={flight} />
            ))}
          </div>


        </Col>
      </Row>
    </div>
  )
}

export default Connection